import React from "react";
import ResultDetails from "./Details/ResultDetails.jsx";
import NavPanel from "../Common/Nav/NavPanel.jsx";
import { FormattedMessage } from "react-intl";

class ResultDetailPerSubmatch extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedDetailKey: 0,
      items: this.mapDetailsToMenu(props.details),
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    this.setState({ selectedDetailKey: e.id });
  }

  componentWillUpdate(nextProps) {
    if (nextProps.details !== this.props.details) {
      this.setState({
        selectedDetailKey: 0,
        items: this.mapDetailsToMenu(nextProps.details),
      });
    }
  }

  isShowGender(details) {
    let genders = {};
    details.forEach((e) => {
      genders[e.submatch.gender] = true;
    });
    return Object.keys(genders).length > 1;
  }

  mapDetailsToMenu(details) {
    let isShowGender = this.isShowGender(details);

    return details.map((e, key) => ({
      id: key,
      name: isShowGender
        ? `${e.submatch.name} ${e.submatch.gender}`
        : e.submatch.name,
    }));
  }

  isPaginationDown(details, offset = 0) {
    return details.length - offset > 5;
  }

  isPaginationUp(offset) {
    return !!offset;
  }

  render() {
    let { details, marked, title } = this.props;
    let { items, selectedDetailKey } = this.state;

    return (
      <div>
        {items.length > 1 ? (
          <NavPanel
            name={title}
            onClick={this.handleClick}
            current={items[selectedDetailKey]}
            items={items}
            showPerPage={6}
          />
        ) : null}
        <Panel title={items.length == 1 ? title : null}>
          <ResultDetails
            onDetailsClick={this.props.onDetailsClick}
            details={details[this.state.selectedDetailKey]["details"]}
            marked={marked}
          />
        </Panel>
      </div>
    );
  }
}

const Panel = ({ children, title }) => (
  <FormattedMessage id="ranking.results">
    {(message) => (
      <section className="module">
        <header className="module__header">
          <h2 className="module__title">{title || message}</h2>
        </header>
        {children}
      </section>
    )}
  </FormattedMessage>
);

export default ResultDetailPerSubmatch;
